import { displayName } from '~/utils/strings';
import { upperFirst } from '~/utils/tool';
import type { OwnerDto } from '~/swagger/portal/Api';
type OwnerLike = { firstName?: string | null; lastName?: string | null };

export const getOwnerName = (owner?: OwnerDto) => displayName(owner?.firstName, owner?.lastName);

export function getOwnerFullName<T extends OwnerLike>(owner?: T | null) {
  if (!owner) return '';
  const name = displayName(owner.firstName, owner.lastName);
  if (!name) return '';
  const [first = '', last = ''] = name.split(' ');
  return `${upperFirst(first)} ${upperFirst(last)}`.trim();
}
